<template>
  <div>
    <PageAllow controller="Payment" action="getPaySettings" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{ $t("Payment.wechatPay.title") }}
          <v-spacer></v-spacer>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <ValidationObserver ref="observer">
            <v-container>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Payment.wechatPay.application") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  {{ $t("Payment.wechatPay.application_title") }}
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.wechatPay.wechat_mini_mch_id") +
                    $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.wechatPay.wechat_mini_mch_id')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="settings.wechat_mini_mch_id"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'wechat_mini_mch_id')
                          .concat(errors)
                      "
                    >
                      <!-- <template v-slot:message="{ key, message }">
                                <div :class="key == 0 ? 'danger--text' : ''">
                                {{ message }}
                                </div>
                            </template> -->
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.wechatPay.wechat_mini_pay_key") +
                    $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.wechatPay.wechat_mini_pay_key')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="settings.wechat_mini_pay_key"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'wechat_mini_pay_key')
                          .concat(errors)
                      "
                    >
                      <!-- <template v-slot:message="{ key, message }">
                                <div :class="key == 0 ? 'danger--text' : ''">
                                {{ message }}
                                </div>
                            </template> -->
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>

              <!-- wechat_mini_cert  -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.wechatPay.wechat_mini_cert") + $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-file-input
                    v-model="wechat_mini_cert"
                    show-size
                    :label="
                      $t('Payment.wechatPay.apiclient_cert_import')
                    "
                    accept=".pem"
                    persistent-hint
                  ></v-file-input>
                  <span v-if="settings.wechat_mini_cert">
                    {{
                      $t("Payment.wechatPay.upload_file", [
                        settings.wechat_mini_cert.split("/")[
                          settings.wechat_mini_cert.split("/").length - 1
                        ],
                      ])
                    }}
                  </span>
                </v-col>
              </v-row>
              <!-- wechat_mini_cert_key   -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.wechatPay.wechat_mini_cert_key") + $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-file-input
                    v-model="wechat_mini_cert_key"
                    show-size
                    :label="
                      $t('Payment.wechatPay.apiclient_key_import')
                    "
                    accept=".pem"
                    persistent-hint
                  ></v-file-input>

                  <span v-if="settings.wechat_mini_cert_key">
                    {{
                      $t("Payment.wechatPay.upload_file", [
                        settings.wechat_mini_cert_key.split("/")[
                          settings.wechat_mini_cert_key.split("/").length - 1
                        ],
                      ])
                    }}
                  </span>
                </v-col>
              </v-row>
              <!-- X -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.wechatPay.wechat_mini_app_id") +
                    $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.wechatPay.wechat_mini_app_id')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="settings.wechat_mini_app_id"
                      single-line
                      disabled
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'wechat_mini_app_id')
                          .concat(errors)
                      "
                    >
                      <!-- <template v-slot:message="{ key, message }">
                                <div :class="key == 0 ? 'danger--text' : ''">
                                {{ message }}
                                </div>
                            </template> -->
                    </v-text-field>
                    <a @click="$router.push('/settings/mini-develop-program')">
                      {{ $t("Payment.wechatPay.mini_develop_program") }}
                    </a>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- X -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.wechatPay.wechat_mini_secret") +
                    $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.wechatPay.wechat_mini_secret')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="settings.wechat_mini_secret"
                      single-line
                      disabled
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'wechat_mini_secret')
                          .concat(errors)
                      "
                    >
                      <!-- <template v-slot:message="{ key, message }">
                                <div :class="key == 0 ? 'danger--text' : ''">
                                {{ message }}
                                </div>
                            </template> -->
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.wechatPay.wechat_official_account_app_id") +
                    $t("Global.colon")
                  }}
                  
                </v-col>
                <v-col cols="9" md="7">
                    <v-text-field
                      v-model="settings.wechat_official_account_app_id"
                      single-line
                    >
                    </v-text-field>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.wechatPay.wechat_official_account_secret") +
                    $t("Global.colon")
                  }}
                  
                </v-col>
                <v-col cols="9" md="7">
                    <v-text-field
                      v-model="settings.wechat_official_account_secret"
                      single-line
                    >
                    </v-text-field>
                </v-col>
              </v-row>
              <!-- 启用 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.wechatPay.wechat_mini_enable") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group row v-model="settings.wechat_mini_enable">
                    <v-radio :label="$t('Payment.off')" key="0" value="0" />
                    <v-radio :label="$t('Payment.on')" key="1" value="1" />
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-container>
          </ValidationObserver>
        </v-card-text>
      </v-card>
      <v-card class="page-opts">
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <!-- 保存 -->
              <v-btn
                color="success"
                block
                @click="
                  settings.wechat_mini_enable ? (alertDialog = true) : save()
                "
              >
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("Payment.save") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>

    <DialogAlert
      v-model="alertDialog"
      :message="$t('Payment.change_wechat_pay', [$t('Payment.wechat')])"
      useConfirm
      @confirm="save()"
    />
  </div>
</template>

<script>
import Payment from "@/api/payment";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import DialogAlert from "@/components/plugins/DialogAlert";
import { mapState } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
// import Required from "@/components/plugins/Required";

export default {
  data: () => ({
    settings: {},
    serverErrors: [],
    alertDialog: false,
    wechat_mini_cert: null,
    wechat_mini_cert_key: null,
  }),
  components: {
    PageAllow,
    Breadcrumbs,
    DialogAlert,
    // Required,
    ValidationObserver,
    ValidationProvider,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.fundManagement"),
        disabled: false,
        href: "/receipts",
      },
      {
        text: i18n.t("Nav.payment"),
        disabled: true,
        href: "/payment",
      },
    ],
    ...mapState(["loading"]),
  },

  mounted() {
    this.getAlipayFromAPI();
  },
  methods: {
    getAlipayFromAPI() {
      Payment.fetch({
        keys: [
          "wechat_mini_mch_id",
          "wechat_mini_pay_key",
          "wechat_mini_app_id",
          "wechat_mini_secret",
          "wechat_mini_enable",
          "wechat_mini_cert",
          "wechat_mini_cert_key",
          "wechat_official_account_app_id",
          "wechat_official_account_secret"
        ],
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.settings = response.data.settings;
            if (
              this.settings.wechat_mini_enable == null ||
              typeof this.settings.wechat_mini_enable == "undefined" ||
              this.settings.wechat_mini_enable == undefined
            ) {
              this.settings.wechat_mini_enable = "0";
            }
          }
        }.bind(this)
      );
    },

    async save() {
      this.$store.dispatch("fullscreenLoading");
      let submitItems = {
        wechat_mini_mch_id: this.settings.wechat_mini_mch_id,
        wechat_mini_pay_key: this.settings.wechat_mini_pay_key,
        wechat_mini_app_id: this.settings.wechat_mini_app_id,
        wechat_mini_secret: this.settings.wechat_mini_secret,
        wechat_mini_enable: this.settings.wechat_mini_enable,
        wechat_mini_cert: this.settings.wechat_mini_cert,
        wechat_mini_cert_key: this.settings.wechat_mini_cert_key,
        wechat_official_account_app_id: this.settings.wechat_official_account_app_id,
        wechat_official_account_secret: this.settings.wechat_official_account_secret,
      };
      if (this.wechat_mini_cert) {
        let response = await Payment.wechatV2FileUpload(1, this.wechat_mini_cert);
        if (response.data.status.isOK()) {
          submitItems.wechat_mini_cert = response.data.wechat_mini_cert;
        }
      }
      if (this.wechat_mini_cert_key) {
        let response = await Payment.wechatV2FileUpload(2, this.wechat_mini_cert_key);
        if (response.data.status.isOK()) {
          submitItems.wechat_mini_cert_key = response.data.wechat_mini_cert_key;
        }
      }
      Payment.weChatPaySave(submitItems).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$router.push("/payment");
          }
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    },
  },
};
</script>

<style>
</style>